
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Container, Row, Input, FormGroup, Label, FormFeedback, InputGroup, InputGroupText , Spinner} from 'reactstrap';
import { confirmResetPassword, resetPassword } from 'aws-amplify/auth';
import AuthSlider from '../AuthenticationInner/authCarousel';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ConfirmResetPass = () => {
    document.title = "Media Pulse | Confirm Password";
    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState(Array(6).fill(''));
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState(null);
    
    const location = useLocation();
    const navigate = useNavigate();
    const { state } = location; 
    const userName = state?.username;
    // console.log(userName);
    
useEffect(()=>{
    if (!userName) {
        navigate("/login")
    }
})
    const handleChangeCode = (index, value) => {
        const updatedCode = [...code];
        updatedCode[index] = value;
        setCode(updatedCode);

        if (value.length === 1 && index < 5) {
            document.getElementById(`digit${index + 2}-input`).focus();
        }
    };

    const handleConfirmResetPassword = async (event) => {
        setLoading(true);
        event.preventDefault();

        const confirmationCode = code.join(''); // Combine code array into a string

        if (newPassword !== confirmNewPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            await confirmResetPassword({ username: userName, confirmationCode, newPassword });
            toast.success('Password reset successful');
            // Navigate to login page after a short delay
            setTimeout(() => {
                navigate('/login');
            }, 1500);
        } catch (error) {
            console.log(error);
            setError(error.message);
            toast.error(error.message);
        }
        setLoading(false);
    };

    const handleResendCode = async () => {
        try {
            await resetPassword({username: userName});
            toast.success('Reset code sent successfully');
        } catch (error) {
            // console.log(error);
            toast.error('Failed to resend reset code');
        }
    };

    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="justify-content-center g-0">
                                        <AuthSlider />
                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <div className="mb-4">
                                                    <div className="avatar-lg mx-auto">
                                                        <div className="avatar-title bg-light text-primary display-5 rounded-circle">
                                                            <i className="ri-mail-line"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="text-muted text-center mx-lg-3">
                                                    <h4 className="">Verify Your Email</h4>
                                                    <p>Please enter the 6 digit code sent to <span className="fw-semibold">{userName}</span></p>
                                                </div>

                                                <div className="mt-4">
                                                    <form onSubmit={handleConfirmResetPassword}>
                                                        <Row>
                                                            {Array.from({ length: 6 }).map((_, index) => (
                                                                <Col className="col-2" key={index}>
                                                                    <div className="mb-3">
                                                                        <label htmlFor={`digit${index + 1}-input`} className="visually-hidden">Digit {index + 1}</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-lg bg-light border-light text-center"
                                                                            maxLength="1"
                                                                            id={`digit${index + 1}-input`}
                                                                            value={code[index]}
                                                                            onChange={(e) => handleChangeCode(index, e.target.value)}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>

                                                        <FormGroup className="mt-4">
                                                            <Label for="new-password">New Password</Label>
                                                            <InputGroup>
                                                                <Input
                                                                    type={showPassword ? "text" : "password"}
                                                                    className="form-control"
                                                                    id="new-password"
                                                                    placeholder="Enter new password"
                                                                    value={newPassword}
                                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                                />
                                                                <InputGroupText
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                                </InputGroupText>
                                                            </InputGroup>
                                                        </FormGroup>

                                                        <FormGroup className="mt-3">
                                                            <Label for="confirm-new-password">Confirm New Password</Label>
                                                            <InputGroup>
                                                                <Input
                                                                    type={showConfirmPassword ? "text" : "password"}
                                                                    className="form-control"
                                                                    id="confirm-new-password"
                                                                    placeholder="Confirm new password"
                                                                    value={confirmNewPassword}
                                                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                                                />
                                                                <InputGroupText
                                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                                </InputGroupText>
                                                            </InputGroup>
                                                        </FormGroup>

                                                        {error && <FormFeedback className="d-block">{error}</FormFeedback>}

                                                        <div className="mt-3">
                                                            <Button color="success" disabled={loading} className="w-100" type="submit">
                                                            {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> :"Confirm"}</Button>
                                                        </div>
                                                    </form>
                                                </div>

                                                <div className="mt-5 text-center">
                                                    <p className="mb-0">Didn't receive a code? <span onClick={handleResendCode} className="fw-semibold text-primary text-decoration-underline" style={{cursor: 'pointer'}}>Resend</span></p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} Whistlemind Technologies LLP. Crafted with <i className="mdi mdi-heart text-danger"></i> </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>

            {/* Toast Container */}
           
        </React.Fragment>
    );
};

export default ConfirmResetPass;
